import React from 'react';
import { connect } from 'react-redux';
import { Button, Modal } from 'react-bootstrap';
import ZoneDetail from '../../components/zone/ZoneDetail';

import { translate } from 'react-i18next';
import { defaultRejectHandler } from '../../utils/utility';
import { createZone } from '../../redux/zone/zone_actions';

class ZoneCreateModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isValid: false,
      isDirty: false,
      isSubmittable: false,
    };

    this.zoneDetail = undefined;
  }

  onSaveHandler() {
    const newZone = this.zoneDetail.getWrappedInstance().getWrappedInstance().getZoneData();
    this.props.createZone(newZone);
  }

  render() {
    const { isCreating, errorMessage, createZone, floor, building, t, ...newProps } = this.props;
    const { isSubmittable } = this.state;
    return (
      <Modal
        {...newProps}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('create zone')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ZoneDetail
            floor={floor}
            building={building}
            ref={ref => (this.zoneDetail = ref)}
            onValid={isValid => this.setState({ isValid })}
            onDirty={isDirty => this.setState({ isDirty })}
            onSubmittable={isSubmittable => this.setState({ isSubmittable })}
            fieldErrors={errorMessage}
            onSubmit={() => !this.props.isCreating && !this.props.isCreated && this.onSaveHandler()}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="zone-submit-create"
            disabled={!isSubmittable || isCreating}
            onClick={() => this.onSaveHandler()}
          >
            {isCreating ? `${t('saving')}...` : t('save')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  errorMessage: state.zone.errorMessage,
  isCreating: state.zone.isCreating,
});

const mapDispatchToProps = (dispatch, props) => ({
  createZone: zone =>
    defaultRejectHandler(
      dispatch(createZone(zone.name, zone.area, zone.floor_id, zone.description, props.building.id)),
    ),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(ZoneCreateModal),
);



// WEBPACK FOOTER //
// ./src/modal/zone/ZoneCreateModal.js